/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_QueuesInputs */

const en_nav_queues = /** @type {(inputs: Nav_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queues`)
};

const de_nav_queues = /** @type {(inputs: Nav_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queues`)
};

/**
* | output |
* | --- |
* | "Queues" |
*
* @param {Nav_QueuesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_queues = /** @type {((inputs?: Nav_QueuesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_QueuesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_queues(inputs)
	return de_nav_queues(inputs)
});